export default __webpack_public_path__ + "static/media/herobanerimage.a202e0fa.svg";